import React, { useState } from 'react';
import { Button, DatePicker } from 'antd';
import { FaCamera } from '@react-icons/all-files/fa/FaCamera';
import './index.scss';


const PersonalDetailsStep = (props) => {
  const [showAdditional, setShowAdditional] = useState(false);
  const { params, onChange } = props;

  const onContinueClick = () => {
    props.onContinueClick();
  };
  return (
    <div className="step personal-details-step">
      <div className="step-inner-content">
        <div className="step-header">
          <h2>Personal details</h2>
          <p>Personal details such as name and job title are essential in a resume to give the recruiter a quick overview of the candidate.</p>
        </div>
        <div className="step-fields">
          <div className="row">
            <div className="field">
              <label>First name</label>
              <input
                type="text"
                placeholder="John"
                value={params.firstName || ''}
                onChange={e => onChange('firstName', e.target.value)}
              />
            </div>
            <div className="field">
              <label>Last name</label>
              <input
                type="text"
                placeholder="Smith"
                value={params.lastName || ''}
                onChange={e => onChange('lastName', e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="field" style={{ flex: 2 }}>
              <label>Desired job title</label>
              <input
                type="text"
                placeholder="Rocket Scientist"
                value={params.title || ''}
                onChange={e => onChange('title', e.target.value)}
              />
            </div>
          </div>
          <div className="additional-details-toggle" onClick={() => setShowAdditional(v => !v)}>
            <span className="toggle-icon">{showAdditional ? '—' : '+'}</span>
            {showAdditional ? 'Hide additional details' : 'Show additional details'}
          </div>
          {showAdditional && (
            <div className="additional-details">
              <div className="row">
                <div className="field">
                  <label>Nationality</label>
                  <input
                    type="text"
                    placeholder="United States"
                    value={params.nationality || ''}
                    onChange={e => onChange('nationality', e.target.value)}
                  />
                </div>
                <div className="field">
                  <label>Driver's License</label>
                  <input
                    type="text"
                    placeholder="D74837465"
                    value={params.driversLicense || ''}
                    onChange={e => onChange('driversLicense', e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="field">
                  <label>Date of Birth</label>
                  <DatePicker
                    style={{ width: '100%' }}
                    placeholder="03 Feb 1996"
                    format="DD MMM YYYY"
                    value={params.dateOfBirth}
                    onChange={date => onChange('dateOfBirth', date)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="step-footer">
        <div className="left">

        </div>
        <div className="right">
        <Button loading={props.formLoading} onClick={onContinueClick} className="next-btn">Next <span className="arrow">&rarr;</span></Button>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailsStep;
